import $ from 'jquery'
import Player from '@vimeo/player'

export default () => {
    showVideo()
}

function showVideo() {
    let vimeoWrapper = $('.vimeo-wrapper')

    if (vimeoWrapper.length <= 0) {
        return
    }

    let player = new Player(vimeoWrapper.find('iframe').get(0))

    player.ready().then(() => {
        setTimeout(() => {
            $(vimeoWrapper.data('hide')).addClass('opacity-0')

            setTimeout(() => {
                $(vimeoWrapper.data('hide')).addClass('hide').removeClass('opacity-0')
            }, 500)

            player.play()
        }, 1500)
    })
}
